import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
//import About from './about';
//import Editor from './editor';
import Pages from './pages';



const root = ReactDOM.createRoot(document.getElementById('ai-editor'));
root.render(<Pages />);


